// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"1a07b668","348":"eda26327"}[chunkId] + ".chunk.css";
};